// i18n.js 
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
        "기업형_메타버스_플랫폼_서비스": "MXSPACE"
      }
  },
  ko: {
    translation: {
    //소개 페이지
        // 상단 메인
            "기업형_메타버스_플랫폼_서비스": "기업형 메타버스 플랫폼 서비스",
        // move to mxspace
            // pc
            "기술_산업에_특화된_맞춤형_메타버스_서비스": "기술 산업에 특화된 맞춤형 메타버스 서비스",
            "원거리_언텍트_업무_협의와_각종_문서,_영상_공유가_가능하며": "원거리 언텍트 업무 협의와 각종 문서, 영상 공유가 가능하며",
            "상상했던_모든_것이_Online_MXSPACE_공간속에서_Offline의_실제_기기_제어까지_현실로_가능해집니다.": "상상했던 모든 것이 Online MXSPACE 공간속에서 Offline의 실제 기기 제어까지 현실로 가능해집니다.",
            // mobile, tablet
            "원거리_언텍트_업무_협의와_각종_문서,_영상_공유가": "원거리 언텍트 업무 협의와 각종 문서, 영상 공유가",
            "가능하며_Online_MXSPACE_공간속에서": "가능하며 Online MXSPACE 공간속에서",
            "Offline의_실제_기기_제어까지_현실로_가능해집니다.": "Offline의 실제 기기 제어까지 현실로 가능해집니다.",
            "상상했던_모든_것이_현실로_이어집니다.": "상상했던 모든 것이 현실로 이어집니다.",
        // mxspace Functions
            // pc
            "사용자_지정_환경에_맞는_다양한_제품을_공간_커스텀을_통해":"사용자 지정 환경에 맞는 다양한 제품을 공간 커스텀을 통해",
            "기업에_특화된_협업_시스템으로_보다_높은_업무_효율을_제공합니다.":"기업에 특화된 협업 시스템으로 보다 높은 업무 효율을 제공합니다.",
            // mobile, tablet
            "사용자_지정_환경에_맞는_다양한_제품을":"사용자 지정 환경에 맞는 다양한 제품을",
            "공간_커스텀을_통해_기업에_특화된_협업":"공간 커스텀을 통해 기업에 특화된 협업",
            "시스템으로_보다_높은_업무_효율을_제공합니다.":"시스템으로 보다 높은 업무 효율을 제공합니다.",
        // communication
            // 공통
            "MXSPACE안에서는_다수의_사람과":"MXSPACE안에서는 다수의 사람과",
            "다양한_형태로_커뮤니케이션이_가능합니다.":"다양한 형태로 커뮤니케이션이 가능합니다.",
        // a variety of platforms
            // 공통
            "모바일_및_PC,_다양한_플랫폼에서_지원가능합니다.":"모바일 및 PC, 다양한 플랫폼에서 지원가능합니다.",
        
        // footer
            "찾아오시는_길":"찾아오시는 길",
            "개인정보처리방침":"개인정보처리방침",
            "회사_주소":"서울 성동구 성수일로4길 25, 19층",
            "문의하기":"문의하기",
    }
  }
};
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "ko",
    fallbackLng: "ko"
  });
export default i18n;